import PageContainer from '../../components/PageContainer/PageContainer';
import { Grid, Box, Button, Typography, Paper } from '@mui/material';
import { Settings as SettingsIcon } from '@mui/icons-material';
import { BillingCard } from '../../components/BillingCard/BillingCard';
import { billingData } from './data';
import { useCreateStripePortalSession } from '../../hooks/useCreateStripePortalSession';
import { useOrganizationBillingInfo } from '../../hooks/useOrganizationBillingInfo';

export function Billing() {
  const { createPortalSession, loading: portalLoading } = useCreateStripePortalSession();
  const { orgBillingInfo, loading: billingLoading } = useOrganizationBillingInfo();

  const handleManageSubscription = async () => {
    const { data } = await createPortalSession();

    if (data?.createStripePortalSession?.url) {
      window.location.href = data.createStripePortalSession.url;
    }
  };

  return (
    <PageContainer
      title={`Billing`}
      description="Ready to get started? See which package is for you."
      testid="billing-page"
    >
      {/* Manage Subscription Section */}
      <Box sx={{ mb: 4, px: 6 }}>
        <Paper sx={{ p: 3, backgroundColor: 'background.paper' }}>
          <Box display="flex" justifyContent="space-between" alignItems="center">
            <Box>
              <Typography variant="h5" gutterBottom>
                Manage Your Subscription
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Update payment methods, view billing history, and manage your subscription settings.
              </Typography>
            </Box>
            <Button
              variant="contained"
              color="primary"
              onClick={handleManageSubscription}
              disabled={billingLoading || portalLoading || !orgBillingInfo?.stripe_customer_id}
              startIcon={<SettingsIcon />}
              size="small"
            >
              {portalLoading ? 'Loading...' : 'Manage Subscription'}
            </Button>
          </Box>
        </Paper>
      </Box>

      <Grid container spacing={3} sx={{ px: 6 }}>
        {billingData.map((billing, index) => (
          <Grid size={{ xs: 12, md: 4 }} key={index}>
            <BillingCard {...billing} />
          </Grid>
        ))}
      </Grid>
    </PageContainer>
  );
}

export default Billing;
